import { render, staticRenderFns } from "./task-detail-header-description.vue?vue&type=template&id=6b06603b&"
import script from "./task-detail-header-description.vue?vue&type=script&lang=ts&"
export * from "./task-detail-header-description.vue?vue&type=script&lang=ts&"
import style0 from "./task-detail-header-description.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports